(function($) {

$(document).ready(function () {

	if($(window).width() < 576) $('.tab-pane').removeClass('active show');

	var active_tab_id = '#';

	$('.nav-tabs').find('.nav-link').each(function(){
		if($(this).hasClass('active')) active_tab_id = $(this).attr('href'); 
	});

	$(window).resize(function(){
		if($(window).width() > 576) {
			$('.nav-tabs').find('.nav-link').each(function(){
				if($(this).attr('href') == active_tab_id) $(this).addClass('active');
				else $(this).removeClass('active');
			});
			$('.tab-pane').each(function(){
				if('#' + $(this).attr('id') == active_tab_id) $(this).addClass('active show');
				else $(this).removeClass('active show');
			});
		}
	});

	$('.tab-title-xs').click(function(){
		//$(this).closest('.tab-pane').toggleClass('active show');

		if(!$(this).closest('.tab-pane').hasClass('active')){
			$(this).closest('.tab-pane').addClass('active show');
			active_tab_id = '#' + $(this).closest('.tab-pane').attr('id');
			$('.nav-tabs').find('.nav-link').each(function(){
				if($(this).attr('href') == active_tab_id) $(this).addClass('active');
				else $(this).removeClass('active');
			});
		} else {
			$(this).closest('.tab-pane').removeClass('active show');
		}
	});


	setTimeout(function(){
		$('.locations-popup-bg').fadeIn(300);
		$('.locations-popup').fadeIn(300);
	}, 3000);

	$(document).on('click', function (event) {
		if ($(event.target).closest(".locations-popup").length) {return;}
		event.stopPropagation();
		$('.locations-popup-bg').fadeOut(300);
		$('.locations-popup').fadeOut(300);
	});

	$(document).on('click', '.locations-popup-close', function () {
		$('.locations-popup-bg').fadeOut(300);
		$('.locations-popup').fadeOut(300);
	});


});

})(jQuery);